const protocol = window.location.protocol + '//';
const hostname = window.location.hostname;
const origin = protocol + hostname;

export const authBaseURL = hostname.includes('localhost')
    ? origin + ':7000'
    : origin;